import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { getGebietColor, getGebietLabel } from "common/wencoGebietColors";
import {
  isWencoDemoModeEnabled,
  isWencoMapCustomersEnabled,
  WENCO_DEMO_MODE_CHANGED
} from "common/wencoDemoMode";
import { getEnhancedFilteredShipments } from "features/shipment/state/selectors";

const LegendPanel = styled.div`
  position: absolute;
  left: 12px;
  bottom: 12px;
  z-index: 2;
  max-width: 220px;
  max-height: 40%;
  overflow: auto;
  padding: 10px 12px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1.35;
  pointer-events: auto;
`;

const LegendTitle = styled.div`
  font-weight: 600;
  margin-bottom: 8px;
`;

const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

const Swatch = styled.span`
  flex: 0 0 12px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.$color};
  border: 1px solid rgba(0, 0, 0, 0.12);
`;

function collectGebiete(shipmentsMap) {
  const gebiete = new Set();
  Object.values(shipmentsMap).forEach(shipment => {
    const gebiet =
      shipment.wenco?.gebiet ||
      shipment.import_logisticcompany_external_label ||
      "";
    if (gebiet) {
      gebiete.add(String(gebiet));
    }
  });
  return [...gebiete].sort((a, b) => a.localeCompare(b, "de"));
}

const WencoMapLegend = ({ shipments, visible }) => {
  const [demoEnabled, setDemoEnabled] = useState(isWencoDemoModeEnabled());

  useEffect(() => {
    const onDemoChange = () => setDemoEnabled(isWencoDemoModeEnabled());
    window.addEventListener(WENCO_DEMO_MODE_CHANGED, onDemoChange);
    return () =>
      window.removeEventListener(WENCO_DEMO_MODE_CHANGED, onDemoChange);
  }, []);

  const gebiete = useMemo(() => collectGebiete(shipments), [shipments]);

  if (
    !visible ||
    !demoEnabled ||
    !isWencoMapCustomersEnabled() ||
    gebiete.length === 0
  ) {
    return null;
  }

  return (
    <LegendPanel>
      <LegendTitle>Gebiete</LegendTitle>
      {gebiete.map(gebiet => (
        <LegendRow key={gebiet}>
          <Swatch $color={getGebietColor(gebiet)} />
          <span>{getGebietLabel(gebiet)}</span>
        </LegendRow>
      ))}
    </LegendPanel>
  );
};

WencoMapLegend.propTypes = {
  shipments: PropTypes.shape({}).isRequired,
  visible: PropTypes.bool
};

WencoMapLegend.defaultProps = {
  visible: false
};

const mapStateToProps = state => ({
  shipments: getEnhancedFilteredShipments(state)
});

export default connect(mapStateToProps)(WencoMapLegend);
